import { FC } from "react"
import { Pencil } from "lucide-react"
import RowOptions from "../../../table/row-options"
import { PricingProfileEntity } from "../../../../../types"

interface Props {
  info: PricingProfileEntity
  onEdit: (profile: PricingProfileEntity) => void
  onDelete: (id: string) => void
}

const MenuCell: FC<Props> = ({ info, onEdit, onDelete }) => {
  return (
    <td className="relative whitespace-nowrap py-4 px-0 text-right text-sm font-medium sm:pr-6 pl-3 pr-4">
      <RowOptions
        actions={[{ label: "Edit", icon: Pencil, onClick: () => onEdit(info) }]}
        deleteAction={() => onDelete(info.id)}
      />
    </td>
  )
}

export default MenuCell
